import { render, staticRenderFns } from "./productSeckillManage.vue?vue&type=template&id=deb8de3a&scoped=true"
import script from "./productSeckillManage.vue?vue&type=script&lang=js"
export * from "./productSeckillManage.vue?vue&type=script&lang=js"
import style0 from "./productSeckillManage.vue?vue&type=style&index=0&id=deb8de3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb8de3a",
  null
  
)

export default component.exports